export const toggleSwitchTheme = {
  // Size tokens must live under `root` so they deepMerge into Aura's root and
  // win. Top-level height/width emit the same CSS vars as Aura's root tokens but
  // earlier in the rule, so Aura's smaller defaults overwrite them.
  root: {
    height: 'var(--input-switch-height)',
    width: 'var(--three-rem)',
    borderWidth: '1px',
    borderRadius: '30px',
    gap: 'var(--quarter-rem)',
    transitionDuration: '0.2s',
    slideDuration: '0.2s',
  },
  handle: {
    size: 'var(--one-quarter-rem)',
    borderRadius: '50%',
  },
  extend: {
    agility: {},
  },
  colorScheme: {
    light: {
      root: {
        background: 'var(--transparent)',
        hoverBackground: 'var(--transparent)',
        disabledBackground: 'var(--p-surface-500)',
        borderColor: 'var(--p-surface-500)',
        hoverBorderColor: 'var(--p-surface-500)',
        checkedBorderColor: 'var(--p-surface-500)',
        checkedHoverBorderColor: 'var(--p-surface-500)',
        invalidBorderColor: 'var(--p-danger-500)',
        shadow: 'var(--reset)',
      },
      handle: {
        background: 'var(--p-surface-500)',
        hoverBackground: 'var(--p-surface-500)',
        disabledBackground: 'var(--p-surface-300)',
      },
    },
    dark: {
      root: {
        background: 'var(--transparent)',
        hoverBackground: 'var(--transparent)',
        disabledBackground: 'var(--p-surface-700)',
        borderColor: 'var(--p-surface-700)',
        hoverBorderColor: 'var(--p-surface-700)',
        checkedBorderColor: 'var(--p-surface-700)',
        checkedHoverBorderColor: 'var(--p-surface-700)',
        invalidBorderColor: 'var(--p-danger-500)',
        shadow: 'var(--reset)',
      },
      handle: {
        background: 'var(--p-surface-700)',
        hoverBackground: 'var(--p-surface-700)',
        disabledBackground: 'var(--p-surface-500)',
      },
    },
  },
};
